module.exports = __webpack_public_path__ + "static/logo-1-cropped-8c2e633466ad4025196e50b660836a8a.jpg";